window.Reverb = window.Reverb || {};

Reverb.Cart = (function () {
  const cartQuantitySelector = '[data-cart-quantity]';
  const paymentSelectionForm = '[data-payment-selection-form]';

  function init() {
    bindQuantityChange();
    bindPaymentSelectionChange();
  }

  function moveCartItemToWatchList(domId, message, destinationContainer, content, messageDisplayDelay) {
    if (!messageDisplayDelay) { messageDisplayDelay = 1000; }

    Reverb.UI.spinWithMessage(`#${domId}`, message);
    setTimeout(() => {
      const elem = $(`#${domId}`);
      elem.slideUp('fast', function () {
        const parent = $(this).parent();
        $(this).remove();
        if (parent.children().length == 0) {
          parent.remove();
        }
      });
      $(destinationContainer).prepend(content);
    }, messageDisplayDelay);
  }

  function bindQuantityChange() {
    $(document).on('change', cartQuantitySelector, function () {
      submitForm(this);
    });
  }

  function bindPaymentSelectionChange() {
    $(document).on('change', paymentSelectionForm, function () {
      submitForm(this);
    });
  }

  function submitForm(changedEl) {
    const select = $(changedEl);
    const form = select.closest('form');
    form.submit();
  }

  return {
    init,
    moveCartItemToWatchList,
  };
}());

$(Reverb.Cart.init);
